/* unplugin-vue-components disabled */import { render } from "./style1.vue?vue&type=template&id=8140c58e&scoped=true"
import script from "./style1.vue?vue&type=script&lang=js"
export * from "./style1.vue?vue&type=script&lang=js"

import "./style1.vue?vue&type=style&index=0&id=8140c58e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8140c58e"]])

export default __exports__